(function(){
  var LOGO_URL = 'https://cdn.shopify.com/s/files/1/0741/4258/1019/files/jordiana-li-logo-horizontal.svg';

  document.addEventListener('click', function(e){
    var btn = e.target.closest('[data-recipe-print]');
    if (!btn) return;
    var card = document.getElementById('recipe-card');
    if (!card) { window.print(); return; }

    var clone = card.cloneNode(true);
    var actions = clone.querySelector('.jl-recipe-card__actions');
    if (actions) actions.remove();
    var video = clone.querySelector('.jl-recipe-card__video');
    if (video) video.remove();

    var win = window.open('', '_blank', 'width=800,height=900');
    if (!win) { window.print(); return; }
    var title = document.title || 'Receta';
    var year = new Date().getFullYear();

    var css = ''
      + "@import url('https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600;700&display=swap');"
      + 'body{font-family:"Poppins",Arial,sans-serif;color:#2b2b2b;padding:32px;max-width:760px;margin:0 auto;line-height:1.5;font-size:13px;}'
      + 'h2,h3,h4{margin:14px 0 8px;font-weight:600;}'
      + 'h2{font-size:1.4rem;}'
      + '.jl-print-header{text-align:center;border-bottom:2px solid #e8a0b4;padding-bottom:16px;margin-bottom:20px;}'
      + '.jl-print-header img{max-width:200px;height:auto;margin:0 auto;display:block;}'
      // Header: imagen + titulo lado a lado (igual que en pantalla, sin float roto)
      + '.jl-recipe-card__header{display:flex;gap:18px;align-items:center;margin-bottom:16px;}'
      + '.jl-recipe-card__media img,.jl-recipe-card__media{width:130px;height:130px;object-fit:cover;border-radius:14px;display:block;flex:0 0 auto;}'
      + '.jl-recipe-card__heading-group{flex:1;}'
      + '.jl-recipe-card__kicker{text-transform:uppercase;letter-spacing:0.08em;font-size:0.7rem;color:#999;margin:0 0 4px;}'
      + '.jl-recipe-card__title{margin:0;font-size:1.5rem;line-height:1.15;}'
      + '.jl-recipe-card__meta{display:flex;flex-wrap:wrap;gap:18px;margin:16px 0;padding:12px 0;border-top:1px solid #ddd;border-bottom:1px solid #ddd;}'
      + '.jl-recipe-meta{display:flex;flex-direction:column;}'
      + '.jl-recipe-meta__label{font-size:0.65rem;text-transform:uppercase;color:#999;letter-spacing:0.03em;}'
      + '.jl-recipe-meta__value{font-weight:600;}'
      + '.jl-recipe-card__body{margin:16px 0;}'
      + '.jl-recipe-card__ingredients ul,.jl-recipe-card__ingredients{columns:2;column-gap:28px;}'
      + '.jl-recipe-card__ingredients li{list-style:none;padding-left:20px;position:relative;break-inside:avoid;margin-bottom:5px;}'
      + '.jl-recipe-card__ingredients li:before{content:"\\2610";position:absolute;left:0;color:#e8a0b4;}'
      + '.jl-recipe-group{font-weight:600;margin-top:12px;color:#753943;column-span:all;}'
      + '.jl-recipe-card__instructions ol,.jl-recipe-card__instructions{padding-left:20px;}'
      + '.jl-recipe-card__instructions li{list-style:decimal;margin-bottom:8px;page-break-inside:avoid;}'
      + 'ul,ol{padding-left:20px;}'
      + '.jl-recipe-card__rating,.jl-recipe-btn,.jl-recipe-card__actions{display:none!important;}'
      + '.jl-print-footer{margin-top:28px;padding-top:14px;border-top:1px solid #e8a0b4;text-align:center;font-size:0.72rem;color:#888;}'
      + '.jl-print-footer strong{color:#753943;}'
      + '@media print{body{padding:0 8px;} .jl-print-header,.jl-print-footer{break-inside:avoid;}}';

    var header = '<div class="jl-print-header"><img src="'+LOGO_URL+'" alt="Jordiana Li"></div>';
    var footer = '<div class="jl-print-footer">Receta de <strong>Jordiana Li &middot; Escuela de Reposteria Online</strong><br>jordianali.com &middot; &copy; '+year+'</div>';

    win.document.write('<!doctype html><html lang="es"><head><meta charset="utf-8"><title>'+title+'</title><style>'+css+'</style></head><body>'+header+clone.innerHTML+footer+'</body></html>');
    win.document.close();
    win.focus();
    setTimeout(function(){ win.print(); win.close(); }, 700);
  });
})();
